import type {
  DOMLocationSelector,
  PageUrlSelector,
  Selector,
  SelectorType,
  SelectorTypeToSelector,
} from '@carboncopyco/types';

export function getSelector<T extends SelectorType>(
  selectors: Selector[],
  selectorType: T
) {
  return selectors.find(
    (selector): selector is SelectorTypeToSelector[T] =>
      selector.type === selectorType
  );
}

export const filterPageUrlSelectors = (
  selectors: Selector[]
): Exclude<Selector, PageUrlSelector>[] => {
  return selectors.filter(isNotPageUrlSelector);
};

export const isNotPageUrlSelector = (
  selector: Selector
): selector is Exclude<Selector, PageUrlSelector> => {
  return selector.type !== 'page_url';
};

export const isPageUrlSelector = (
  selector: Selector
): selector is PageUrlSelector => {
  return selector.type === 'page_url';
};

export const isDOMLocationSelector = (
  selector: Selector
): selector is DOMLocationSelector => {
  return selector.type === 'dom_location';
};
